function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "78",
  height: "68"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: "40.39",
  y1: "33.57",
  x2: "60.91",
  y2: "54.09",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#676e96"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: "46",
  y1: "55",
  x2: "78",
  y2: "55",
  xlinkHref: "#linear-gradient"
})), /*#__PURE__*/React.createElement("path", {
  d: "M71 38.36V41H47a2 2 0 00-2 2v17h-4a2 2 0 01-2-2V36a2 2 0 012-2h6.78a2 2 0 011.4.58l1.24 1.21a2 2 0 001.4.57H69a2 2 0 012 2z",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77 42H47a1 1 0 00-1 1v24a1 1 0 001 1h30a1 1 0 001-1V43a1 1 0 00-1-1zm-1 4h-3v-2h3zm-5 0h-3v-2h3zm-5 0h-3v-2h3zm-5 0h-3v-2h3zm-5 0h-3v-2h3zm-5 0h-3v-2h3zm25 20h-3v-2h3zm-5 0h-3v-2h3zm-5 0h-3v-2h3zm-5 0h-3v-2h3zm-5 0h-3v-2h3zm-5 0h-3v-2h3z",
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/React.createElement("rect", {
  x: "48",
  y: "48",
  width: "28",
  height: "14",
  rx: "1",
  fill: "#fff",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48 57.91V61a1 1 0 001 1h26a1 1 0 001-1v-3.09a7 7 0 01-2.11 1.3c-5.56 2.14-10.44-4.82-17.65-4.64A13.72 13.72 0 0048 57.91z",
  fill: "#fff",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "71",
  cy: "53",
  r: "3",
  fill: "#fff",
  opacity: ".2"
}));